import userTree from '../apis/userTree';
import { GET_USER_TREE } from "./types";
import { protectedResources } from "../authConfig";
import { msalInstance } from "../index";
import eventBus from '../common/EventBus';

const getToken = async () => {
    const account = msalInstance.getActiveAccount();

    if (!account) {
        eventBus.dispatch("logout");
        throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }

    const response = await msalInstance.acquireTokenSilent({
        account: account,
        ...protectedResources.apiTodoList.scopes
    });

    return response.accessToken;
}

export const getUserTree = (userIsolates, dataTableColumns) => {
    
    
    return async (dispatch, getState) => {
        const token = await getToken();
        try {
            const config = {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                data: {},
            };

            if (!userIsolates) {
                const response = await userTree.get(
                    '/user_tree',
                    config,
                );

                dispatch({
                    type: GET_USER_TREE,
                    payload: response.data,
                    newColumnData: dataTableColumns
                });
            } else {
                const response = await userTree.post(
                    '/user_tree',
                    {
                        data: {
                            isolates: userIsolates
                        },
                    },
                    config,
                );

                dispatch({
                    type: GET_USER_TREE,
                    payload: response.data,
                    newColumnData: dataTableColumns
                });
            }
        }
        catch (error) {
            console.log(error);
        }
    }
};
